var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative text-4xl sign",class:{ off: !_vm.$store.state.light },style:(_vm.signStyle)},[_c('b',[_vm._v("o")])])}
var staticRenderFns = []

export { render, staticRenderFns }